module.exports = __webpack_public_path__ + "static/media/Sectoral_Thematic.37e5dc5a.svg";